import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';

const BrandFontSelect = ({ fonts, selectedFont, handleSelect }) => {
  const renderMenuItem = useCallback(
    (font) => (
      <React.Fragment key={font.id}>
        <MenuItem
          active={selectedFont.name === font.name}
          eventKey={font.id}
          onSelect={() => handleSelect(font, 'fontName')}
        >
          <span>{font.name}</span>
        </MenuItem>
      </React.Fragment>
    ),
    [selectedFont]
  );

  return (
    <div className="m-b-8" style={{ flex: 1 }}>
      <h4 className="m-b-8 text-muted">Font</h4>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedFont.name}
          id="statuses-filter"
          className="btn-block"
          onSelect={(value) => handleSelect(value, 'fontName')}
          pullRight
        >
          {fonts.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
};

export default BrandFontSelect;
